import { useNotifications } from '@sequencehq/core-components'
import { useMutation } from '@sequencehq/api'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'

type UpdateMappingParams = {
  id: string
  body: {
    xeroLedgerAccountCode?: string
    xeroLedgerAccountName?: string
    isDefault?: boolean
  }
}

export const useUpdateXeroLedgerAccountMapping = () => {
  const { displayNotification } = useNotifications()

  const updateMappingMutator = useMutation(
    dashboardv99990101Client.putXeroLedgerAccountMapping
  )

  return async ({ id, body }: UpdateMappingParams) => {
    await updateMappingMutator.mutateAsync(
      {
        id,
        body
      },
      {
        onSuccess: () => {
          displayNotification('Xero ledger account mapping updated', {
            type: 'success'
          })
        },
        onError: () => {
          displayNotification('Failed to update Xero ledger account mapping', {
            type: 'error'
          })
        }
      }
    )
  }
}
